import { createHttpEndpoint } from '../../utils'

import type {
  GetFinancialReportMetadataResponse,
  GetFinancialReportResponse,
} from './financial-report.types'

/**
 * Retrieve Financial Report metadata for the new seller-experience service to populate filters selects and display kpis information on the page
 */
export const getFinancialReportMetadata =
  createHttpEndpoint<GetFinancialReportMetadataResponse>({
    method: 'GET',
    operationId: 'getFinancialReportMetadata',
    path: '/api/seller-experience/finance/report/metadata',
  })

/**
 * Retrieve Financial Report metadata for the new seller-experience service to populate filters selects and display kpis information on the page
 */
export const getFinancialReport =
  createHttpEndpoint<GetFinancialReportResponse>({
    method: 'GET',
    operationId: 'getFinancialReport',
    path: '/api/seller-experience/finance/report',
  })
